const env = {
  version: "1.3.5",
  apiUrl: "https://api.whenthen.com/api/graphql",
  sandboxApiUrl: "https://api.sandbox.whenthen.co/api/graphql"
};

var ApiKeyEnvType;

(function (ApiKeyEnvType) {
  ApiKeyEnvType[ApiKeyEnvType["Sandbox"] = 0] = "Sandbox";
  ApiKeyEnvType[ApiKeyEnvType["Live"] = 1] = "Live";
})(ApiKeyEnvType || (ApiKeyEnvType = {}));

var ClientTokenPrefix;

(function (ClientTokenPrefix) {
  ClientTokenPrefix["Sandbox"] = "ct_test_";
  ClientTokenPrefix["Live"] = "ct_live_";
})(ClientTokenPrefix || (ClientTokenPrefix = {}));

var PublicKeyPrefix;

(function (PublicKeyPrefix) {
  PublicKeyPrefix["Sandbox"] = "pk_test_";
  PublicKeyPrefix["Live"] = "pk_live_";
})(PublicKeyPrefix || (PublicKeyPrefix = {}));

var PrivateKeyPrefix;

(function (PrivateKeyPrefix) {
  PrivateKeyPrefix["Sandbox"] = "sk_test_";
  PrivateKeyPrefix["Live"] = "sk_live_";
})(PrivateKeyPrefix || (PrivateKeyPrefix = {}));

const getApiKeyEnvType = apiKey => {
  var _a;

  const normalizedApiKey = (_a = apiKey === null || apiKey === void 0 ? void 0 : apiKey.toLowerCase()) !== null && _a !== void 0 ? _a : '';
  const sandboxPrefixes = [PublicKeyPrefix.Sandbox, ClientTokenPrefix.Sandbox, PrivateKeyPrefix.Sandbox];
  const isSandboxApiKey = sandboxPrefixes.some(prefix => normalizedApiKey.startsWith(prefix));

  if (isSandboxApiKey) {
    return ApiKeyEnvType.Sandbox;
  }

  return ApiKeyEnvType.Live;
};

var ApiKeyType;

(function (ApiKeyType) {
  ApiKeyType[ApiKeyType["ClientToken"] = 0] = "ClientToken";
  ApiKeyType[ApiKeyType["PublicKey"] = 1] = "PublicKey";
  ApiKeyType[ApiKeyType["PrivateKey"] = 2] = "PrivateKey";
  ApiKeyType[ApiKeyType["Unknown"] = 3] = "Unknown";
})(ApiKeyType || (ApiKeyType = {}));

var ApiKeyPrefix;

(function (ApiKeyPrefix) {
  ApiKeyPrefix["ClientToken"] = "ct_";
  ApiKeyPrefix["PublicKey"] = "pk_";
})(ApiKeyPrefix || (ApiKeyPrefix = {}));

const getApiKeyType = apiKey => {
  var _a;

  const normalizedApiKey = (_a = apiKey === null || apiKey === void 0 ? void 0 : apiKey.toLowerCase()) !== null && _a !== void 0 ? _a : '';

  if (normalizedApiKey.startsWith(ApiKeyPrefix.ClientToken)) {
    return ApiKeyType.ClientToken;
  } else if (normalizedApiKey.startsWith(ApiKeyPrefix.PublicKey)) {
    return ApiKeyType.PublicKey;
  } else {
    return ApiKeyType.Unknown;
  }
};

const validateApiKeyType = (apiKey, allowedTypes) => {
  const apiKeyType = getApiKeyType(apiKey);
  const isValid = allowedTypes.includes(apiKeyType);
  return isValid;
};

const getApiUrl = apiKey => {
  const apiKeyEnvType = getApiKeyEnvType(apiKey);

  switch (apiKeyEnvType) {
    case ApiKeyEnvType.Live:
      return env.apiUrl;

    case ApiKeyEnvType.Sandbox:
      return env.sandboxApiUrl;

    default:
      throw new Error(`Unknown api key type.`);
  }
};

class GqlClient {
  constructor(apiKey, url) {
    this.apiKey = apiKey;
    this.url = url;
  }

  async request(query, variables, idempotencyKey) {
    const headers = new Headers();

    if (!!this.apiKey) {
      headers.append('Authorization', `Bearer ${this.apiKey}`);
    }

    headers.append('Content-Type', 'application/json');
    headers.append('X-SDK-Version', env.version);

    if (!!idempotencyKey) {
      headers.append('X-Idempotency-Key', idempotencyKey);
    }

    const graphql = JSON.stringify({
      query: query.trim(),
      variables
    });
    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: graphql,
      redirect: 'follow'
    };
    const result = fetch(this.url, requestOptions).then(response => response.json());
    return result;
  }

}

export { ApiKeyType, GqlClient, env, getApiUrl, validateApiKeyType };
//# sourceMappingURL=index.js.map
